import Image from 'next/image';
import Link from 'next/link';
import type { FC } from 'react';
import { Box, Button } from '@/DesignSystem/Component';
import { LINKS } from '@/Module/Core/Constant';
import { normalizeExamHtml } from '@/Module/Exam/Helper';
import { IconArrowLeft } from '@/Module/Icon';
import { postSelectAll } from '@/Module/Post/Store/Selector';
import { useAppSelector } from '@/Module/Store/Hook';
const HomePageBlogList: FC = () => {
  const list = useAppSelector(postSelectAll);
  if (!list.length) return null;
  return <div className="flex flex-col" data-sentry-component="HomePageBlogList" data-sentry-source-file="HomePageBlogList.tsx">
      <div className="mb-14 grid grid-cols-1 gap-6 sm:gap-12 lg:grid-cols-2">
        {list.map(item => <article className="flex flex-col flex-wrap sm:flex-row" key={item.id}>
            <Box as={Link} href={item.link} color="primaryLight" className="mx-auto mb-6 w-fit border-4 border-blueFour sm:mb-0 md:w-[240px]">
              <Image width={320} height={150} className="h-full object-cover" src={item.fimg_url} alt={item.title?.rendered ?? ''} />
            </Box>
            <div className="flex flex-1 flex-col  sm:pr-4">
              <h5 className="mb-2 line-clamp-3 text-justify text-base font-semibold leading-[30px] text-blackFive sm:text-xl sm:leading-[35px]">
                {item.title?.rendered ?? ''}
              </h5>
              {/* eslint-disable react/no-danger */}
              <div className="mb-2  line-clamp-3 text-justify leading-[30px]  text-blackFive" dangerouslySetInnerHTML={{
            __html: normalizeExamHtml(item.excerpt.rendered)
          }} />
              {/* eslint-enable react/no-danger */}
              <a href={item.link} className="flex flex-row items-center self-end font-bold text-blueFour sm:self-auto">
                <span>ادامه مطلب</span>
                <IconArrowLeft size="small" />
              </a>
            </div>
          </article>)}
      </div>

      <Button as="a" href={LINKS.BLOG} className="self-center" variant="shadow" color="primary" radius="circle" size="large" bold data-sentry-element="Button" data-sentry-source-file="HomePageBlogList.tsx">
        نمایش بیشتر
      </Button>
    </div>;
};
export default HomePageBlogList;